import script from "./integrationsCommons.vue?vue&type=script&lang=js"
export * from "./integrationsCommons.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__